import { defineComponent } from 'vue';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const IMAGE_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'image-control-dsgn',
    mixins: [BaseComponentMixin],
    computed: {
        previewSrc() {
            const src = this.controlData?.Src;
            if (!src || String(src).includes('{'))
                return null;
            return src;
        },
        imageStyle() {
            return {
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
                maxWidth: '100%',
                objectFit: this.controlData?.ObjectFit || 'contain',
            };
        },
        placeholderStyle() {
            return {
                ...this.imageStyle,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#e0e0e0',
                color: '#757575',
                minHeight: '80px',
                minWidth: '120px',
            };
        },
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, IMAGE_CLICK_CODE_BEHIND);
        },
    },
    render() {
        if (!this.controlData)
            return null;

        const content = this.previewSrc
            ? <img src={this.previewSrc} style={this.imageStyle} alt="" />
            : <div style={this.placeholderStyle}>Image</div>;

        return (
            <div
                class={{ 'c-Image': true, 'designer-container': true, selected: this.selected$ }}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                {content}
            </div>
        );
    },
});
